<template id="Autres_immat">
	<div>
		<Modele id="Caracteristiques"/>
		<Modele id="Correction"/>
	</div>
</template>

<script>
import Modele from '../Modele.vue'
export default {
	components:{Modele},
	name: 'Autres_immat',
	data () {
		return {}
	}
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Immatriculation/Autres_immat.vue